<template>
    <div class="faq-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('FAQ.title')}}
                <hr>
            </span>
        </h1>
        <!-- FAQ -->
        <div class="row faq-row">
            <p>{{$t('FAQ.introText')}}</p>
            <router-link to="/ContactUs" class="btn">{{$t('common.contactUs')}}</router-link>
        </div>

        <!-- FAQLIST -->
        <div class="row faq-list">
            <div  class="panel-group" id="accordion">
                <div v-for="(item,index) in faqList[$i18n.locale]" :key="index" class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" 
                            :href="'#'+index">
                            {{item.Q}}
                            </a>
                        </h4>
                    </div>
                    <div :id="index" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p v-html="item.A">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                faqList:{
                    EN:[
                        {
                            Q:"What can MPT Solution do for me?",
                            A:"In short, MPT can design and produce plastic and metal mechanical parts in large quantities, as well as provide product development services. We have advanced equipment and excellent process design capabilities. Not only have we continued to obtain patents, we've also received customer recognition. We can offer our clients flexible options to choose the best combination of services to suit individual needs."
                        },
                        {
                            Q:"What makes MPT Solution’s plastic parts stand out?",
                            A:"MPT Solution specializes in external parts, which usually require painting, texturing, or other finishes to achieve functionalities and aesthetics.</br>Thanks to our MHCM technology, MPT Solution offers better surface quality than other facilities. Our on-site CNAS lab allows us to truly specialize in materials, and therefore provide consulting services for material selection based on your specific and unique use cases."
                        },
                        {
                            Q:"How does MPT Solution mass-produce carbon fiber parts?",
                            A:"We are proud to pioneer the mass production of carbon fiber enclosures. We acquire all carbon fiber prepreg from verified suppliers and form the parts through our one-of-a-kind Hybrid Molding process. This process combines thermoforming and injection molding.<br/>Please contact us to learn more."
                        },
                        {
                            Q:"Who are MPT Solution’s customers?",
                            A:"MPT Solution’s customers are both brand owners and Original Design Manufacturers (ODM).<br/>We work with brand owners directly for mechanical product development, ensuring there are no limitations based on ODM’s manufacturing capabilities.<br/>We also provide Design-for-Manufacturability (DFM) to our customers and work closely with them to finalize premier production designs.<br/>Our customers are across the industries, including computing, consumer, automotive, healthcare, IoT, automation, and industrial.<br/>As an industry-leading manufacturing and development facility, we take our customer’s privacy and intellectual property very seriously."
                        },
                        {
                            Q:"How can I protect my intellectual property while working with MPT Solution?",
                            A:"MPT Solution will work with you to procure a mutual Non-Disclosure Agreement (NDA) at the beginning of our collaboration. We have strict rules and infrastructure to keep the customers’ IPs safe, such as an encrypted cloud drive for file storage and transfer and a dedicated area for development work with security guards 24/7.<br/>MPT Solution has worked with many industry-leading customers who have the highest security requests in the world, so we understand the importance of privacy protection."
                        },
                        {
                            Q:"Our product volume is not large, can we still work with MPT Solution?",
                            A:"Yes, MPT Solution can make parts in small volumes. We understand that often ODM companies may not accept smaller quantities, but we are more than flexible with our manufacturing arrangements.<br/>MPT Solution can help you with system-level manufacturing and assembly, including PCB, PCBA, battery, and display, even if the quantity is relatively small.<br/>Please reach out to us for further information."
                        }
                    ],
                    CN:[
                        {
                            Q:"汉达精密能为我做什么？",
                            A:"简言之，汉达精密可以大量设计生产塑料和金属机构件，以及提供产品开发服务。我们具有先进设备和优秀的制程设计能力。不仅持续取得专利，同时也获得客户的认可。我们可以为客户提供弹性选项，以选择适合个别需求的最佳服务组合。"
                        },
                        {
                            Q:"汉达精密的塑料机构部件为什么能脱颖而出？",
                            A:"汉达精密专精于外观机构部件，此类部件通常需要通过喷漆、咬花或其他表面处理，使其兼具实用和美观。 MHCM 技术使汉达精密可以提供比其他机构件厂商更优异的表面质量。我们的 CNAS 实验室，让我们能真正专注于材料上，因此可以根据您的具体的需求，提供选择材料的咨询服务。"
                        },
                        {
                            Q:"汉达精密如何大量生产碳纤维零件？",
                            A:"我们为可以率先大量生产碳纤维外壳而感到自豪。我们从经过验证的供货商取得所有的碳纤维预浸材料，并透过独一无二的混合成型程序制成零件。此程序结合了热压成型和射出成型。<br/>请与我们联络，以了解更多信息。"
                        },
                        {
                            Q:"汉达精密的客户有哪些？",
                            A:"汉达精密的客户包含品牌所有者以及原始设计制造商 (ODM)。<br/>我们直接与品牌所有者合作开发机构部件，以确保 ODM 的制造能力不会构成限制。<br/>我们可同时为客户提供可制造设计 (DFM)，并与客户密切合作决定首要的生产设计。<br/>我们的客户遍及各个行业，包括运算、消费者、汽车、医疗保健、物联网、自动化和工业。<br/>我们是业界领先的制造和开发机构，非常重视客户的隐私权和知识产权。"
                        },
                        {
                            Q:"在与汉达精密合作时，如何保护我的知识产权？",
                            A:"汉达精密将会与您合作，在我们开始合作时签订一份双方的保密协议 (NDA)。我们已制定严格的规定和基础设施，保障客户们的智慧财产安全，例如储存和传输档案的加密云端磁盘，以及由保全人员全年无休看守的开发工作专用区。<br/>汉达精密与许多业界领先的客户合作，此类客户均具有全世界最高的安全性要求，因此我们非常了解隐私保护的重要性。"
                        },
                        {
                            Q:"我们的产品订单量不大，也能与汉达精密合作吗？",
                            A:"是的，汉达精密可以制造少量的零件。我们理解一般的ODM 公司可能不接受较少的数量，但是我们的生产安排十分具有弹性。<br/>汉达精密可以协助您进行系统级的制造和组装，包括 PCB、PCBA、电池和显示器，即使数量相对较少亦可。<br/>请与我们联络，以获得更多信息。"
                        }
                    ],
                    CHT:[
                        {
                            Q:"漢達精密能為我做什麼？",
                            A:"簡言之，漢達精密可以大量設計生產塑膠和金屬機構件，以及提供產品開發服務。我們具有先進設備和優秀的制程設計能力。不僅持續取得專利，同時也獲得客戶的認可。我們可以為客戶提供彈性選項，以選擇適合個別需求的最佳服務組合。"
                        },
                        {
                            Q:"漢達精密的塑膠機構部件為什麼能脫穎而出？",
                            A:"漢達精密專精於外觀機構部件，此類部件通常需要通過噴漆、咬花或其他表面處理，使其兼具實用和美觀。 MHCM 技術使漢達精密可以提供比其他機構件廠商更優異的表面品質。我們的 CNAS 實驗室，讓我們能真正專注於材料上，因此可以根據您的具體的需求，提供選擇材料的諮詢服務。"
                        },
                        {
                            Q:"漢達精密如何大量生產碳纖維零件？",
                            A:"我們為可以率先大量生產碳纖維外殼而感到自豪。我們從經過驗證的供應商取得所有的碳纖維預浸材料，並透過獨一無二的混合成型程式製成零件。此程式結合了熱壓成型和射出成型。請與我們聯絡，以瞭解更多資訊。"
                        },
                        {
                            Q:"漢達精密的客戶有哪些？",
                            A:"漢達精密的客戶包含品牌所有者以及原始設計製造商 (ODM)。<br/>我們直接與品牌所有者合作開發機構部件，以確保 ODM 的製造能力不會構成限制。<br/>我們可同時為客戶提供可製造設計 (DFM)，並與客戶密切合作決定首要的生產設計。<br/>我們的客戶遍及各個行業，包括運算、消費者、汽車、醫療保健、物聯網、自動化和工業。<br/>我們是業界領先的製造和開發機構，非常重視客戶的隱私權和智慧財產權。"
                        },
                        {
                            Q:"在與漢達精密合作時，如何保護我的智慧財產權？",
                            A:"漢達精密將會與您合作，在我們開始合作時簽訂一份雙方的保密協議 (NDA)。我們已制定嚴格的規定和基礎設施，保障客戶們的智慧財產安全，例如儲存和傳輸檔案的加密雲端磁碟，以及由保全人員全年無休看守的開發工作專用區。<br/>漢達精密與許多業界領先的客戶合作，此類客戶均具有全世界最高的安全性要求，因此我們非常瞭解隱私保護的重要性。"
                        },
                        {
                            Q:"我們的產品訂單量不大，也能與漢達精密合作嗎？",
                            A:"是的，漢達精密可以製造少量的零件。我們理解一般的ODM 公司可能不接受較少的數量，但是我們的生產安排十分具有彈性。<br/>漢達精密可以協助您進行系統級的製造和組裝，包括 PCB、PCBA、電池和顯示器，即使數量相對較少亦可。<br/>請與我們聯絡，以獲得更多資訊。"
                        }
                    ],
                    JP:[
                        {
                            Q:"MPTは、どのような會社ですか？",
                            A:"簡単に言えば、マイタックテクノロジー京都株式會社は、樹脂や金屬部品を大量生産するだけでなく、部品開発サービスも提供します。特許を取得すると同時に、お客様のニーズに見合って、多種類のサービス組み合わせも提供します。"
                        },
                        {
                            Q:"マイタックテクノロジー京都株式會社のメカ部品が際立っている原因は？",
                            A:"当社は外観メカ部品の処理に堪能します。</br>このような部品は塗裝、シボ、およびほかの表面処理等を通して、機能性と美學感を達成します。弊社はMHCM技術を使って、他社より優れた表面品質を提供してします。 <br/>また、弊社on-site CNAS labは材料専念できるので、お客様の特別＆獨特なニーズによって、　材料選択上のお問い合わせサービスが提供可能です。"
                        },
                        {
                            Q:"当社は、CFRTP部品をどうやって大量生産しているのか？",
                            A:"当社は率先にCFRTP parts大量生産することに自慢しています。<br/>検証認定なサプライヤーからCFRTPを購入して、獨特な Hybrid Molding 成形プロセスを通じて生産します。もし詳細な情報必要なら、弊社までにご連絡ください。"
                        },
                        {
                            Q:"当社のお客様群體は？",
                            A:"お客様群體はブランドオーナーやオリジナルデザイン製造業者（ODM）を含んでいます。<br/>弊社は、メカニカル製品開発のために直接的にブランドオーナーと提攜し、ODMの製造能力に基づいて制限がないことを確認しています。<br/>當社はまた、お客様に製造性考慮設計（DFM）を提供し、レベルの高い生産デザインを仕上げるために緊密に協力しています。當社のお客様は、コンピューティング、コンシューマー、自動車、ヘルスケア、loT、オートメーションなどの業界を網羅しています。<br/>業界をリードする製造及び開発施設として、當社は、お客様のプライバシーや知的財産を真剣に考えています。"
                        },
                        {
                            Q:"当社と提攜間、知的財産はどうやって保護することができますか？",
                            A:"お客様と秘密保持契約（NDA）を締結する。當社は、ファイル保管・転送用の暗號化クラウドドライブ、年中無休のセキュリティガード付きの開発作業用エリアなど、お客様のIPを安全に維持するための厳密な規則やインフラを有しております。<br/>当社は、世界中の最も高度なセキュリティ要件を持つ多くの業界をリードするお客様と提攜しているため、プライバシー保護の重要性を理解しています。"
                        },
                        {
                            Q:"生産量は多くはないのですが、マイタックテクノロジー京都株式會社対応できませんか？",
                            A:"はい、マイタックテクノロジー京都株式會社は少數量発注に対応することが可能です。 一般的なODM企業にとって難しいかもしれませんが、弊社は製造調整により弾性的に対応できます。<br/>発注量が少なくても、マイタックテクノロジー京都株式會社は、PCB、PCBA、バッテリー及びディスプレイを含むシステムレベルの製造や組立に協力できます。<br/>詳細な情報が必要な場合は、ご連絡ください。"
                        }
                    ]
                }
            }
        },
        methods:{
            collapse (){
                $('.collapse').collapse()
            }
        }
    }
</script>

<style scoped>
    .faq-row .btn{
        margin:4rem auto;
    }
    .faq-list a{
        text-decoration: none;
    }
    .faq-list .panel-default>.panel-heading{
        background:#fff;
        border:none;
        padding:2rem 4rem;
    }
    .panel-title{
        text-align: left;
        font-size: 3rem;
        font-weight: bold;
        background:url(../../assets/images/arrow_down.png) right center no-repeat;
        background-size: 2% auto;
    }
    .panel-title a{
        display: block;
        text-align: left;
        line-height: 2;
    }
    .faq-list .panel-default{
        border-radius: 0;
        margin-top: 2rem;
    }
    .faq-list p{
        width: 100% !important;
        text-align: left;
        padding:0 2rem;
    }
    @media (max-width: 767px){
        .faq-row .btn{
            margin:1rem auto;
        }
        .faq-list .panel-default>.panel-heading{
            padding:1rem
        }
        .panel-title{
            font-size: .7rem;
            background-size:4% auto ;
        }
        .faq-list .panel-default{
            margin-top: 1rem;
        }
        .faq-list p{
            padding:0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ContactUs/FAQ.vue